import { render, staticRenderFns } from "./UploadTemplate.vue?vue&type=template&id=3f78e728&scoped=true&"
import script from "./UploadTemplate.vue?vue&type=script&lang=js&"
export * from "./UploadTemplate.vue?vue&type=script&lang=js&"
import style0 from "./UploadTemplate.vue?vue&type=style&index=0&id=3f78e728&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f78e728",
  null
  
)

export default component.exports